
    import Generic from "./Generic.vue";
    import Data from "@/ts/application/Data";
    import $ from "jquery";

    import {
        Component,
    } from 'vue-property-decorator';


    @Component
    export default class Dialog extends Generic {
        private status: boolean = false;
        private dialogData: any = null;

        private mounted() {
            $(window).on("DIALOG_OPEN", this.onOpenDialog.bind(this));
            $(window).on("DIALOG_CLOSE", this.onCloseDialog.bind(this));
        }
        // The `onOpenDialog` method in the Vue component is a function that is triggered when a dialog
        // is opened. Here is a breakdown of what it does:
        private onOpenDialog(e: any, data: any) {
            this.dialogData = data;
            this.dialogData.content = this.loc(this.dialogData.content);
            if(this.dialogData.addtitionalContent) this.dialogData.content += "<br/><br/><br/>" + this.dialogData.addtitionalContent;

            this.status = true;
        }
        // The `onCloseDialog()` method in the Vue component is responsible for closing the dialog.
        // When this method is called, it sets the `status` property to `false`, which controls the
        // visibility of the dialog. Additionally, it sets the `dialogData` property to `null`,
        // effectively clearing out any data that was stored for the dialog. This ensures that when the
        // dialog is closed, it is no longer visible and any associated data is reset for the next time
        // the dialog is opened.
        private onCloseDialog() {
            this.status = false;
            this.dialogData = null;
        }
        // The `clickButton` method in the Vue component is responsible for handling the click event on
        // a button within the dialog. Here is a breakdown of what it does:
        private clickButton(id:string){
            let button:any = this.dialogData.buttons[id];

            if(button.callback){
                button.callback();
            }

            this.status = false;
            this.dialogData = null;
        }
    }
